export function combineSignals (signals: AbortSignal[]): AbortSignal {
  if (typeof (AbortSignal as any).any === 'function') {
    return (AbortSignal as any).any(signals);
  }

  const controller = new AbortController() as any;

  for (const signal of signals) {
    if (signal.aborted) {
      controller.abort((signal as any).reason);
      return controller.signal;
    }

    signal.addEventListener('abort', () => controller.abort((signal as any).reason), { once: true });
  }

  return controller.signal;
}
